import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-2.5 bg-white rounded-lg border border-divider flex items-center gap-2.5" }
const _hoisted_2 = { class: "text-xs font-bold text-brown" }
const _hoisted_3 = { class: "text-[11px] text-muted" }


import { Activity } from "@/types/calculators";


export default /*@__PURE__*/_defineComponent({
  __name: 'DoingCardComponent',
  props: {
    activity: {},
    isPositive: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["w-2 h-2 rounded-full shrink-0", __props.isPositive ? 'bg-success' : 'bg-error'])
    }, null, 2),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.activity.name), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.activity.ua), 1)
    ])
  ]))
}
}

})